var moment = require("moment");
export default {
    data() {
        return {
            _toast: { message: "loading..", forbidClick: true, overlay: true, duration: 0, },
        }
    },
    methods: {
        gMsgbox(msg, title = "") { //彈出訊息
            return this.$dialog.confirm({
                title: title,
                // message: JSON.stringify(msg),
                message: msg,
                showCancelButton: false,
                // theme: 'round-button',

            });
        },
        gSure(msg, title = "") { //彈出對話框，可以選"確認","取消"
            return this.$dialog.confirm({
                title: title,
                // message: JSON.stringify(msg),
                message: msg,
                // theme: 'round-button',
            });
        },
        gLoading() { //載入轉圈圈
            this.$toast.loading({
                message: "loading..",
                forbidClick: true,
                overlay: true,
                duration: 0,
            });
        },
        gClearLoading() { // 清除loading
            this.$toast.clear();
        },
        gScrollTo(id) {
            // this.$VueScrollTo.scrollTo("#element");
            this.$VueScrollTo.scrollTo(id);
        },
        gMsg(text, type = "success") { //輕提示3秒，會自動關閉
            // type= "success" , "warning" , "error" 
            this.$message({
                showClose: true,
                // message: JSON.stringify(text),
                message: text,
                type: type
            });
        },
        sumJson(jsonArray, key) {
            if (jsonArray == undefined) { return ""; }
            if (key == undefined) { return ""; }
            if (jsonArray.length == 0) { return 0; }
            return jsonArray.map(r => r[key]).reduce((sum, qty) => sum + qty);
        },
        gSum(array, key) {
            if (array == undefined) { return ""; }
            if (key == undefined) { return ""; }
            if (array.length == 0) { return 0; }
            return array.map(r => r[key]).reduce((tmp, qty) => tmp + qty);
        },
        str(value) {
            if (value == undefined) { return ""; }
            if (value == null) { return ""; }
            return value.toString().trim();
        },
        quot(value, len = 0) {
            if (len > 0) { value = value.substring(0, len) }
            return "'" + this.str(value) + "'";
        },
        quotes(value, len = 0) {
            if (len > 0) { value = value.substring(0, len) }
            return '"' + this.str(value) + '"';
        },
        val(value) {
            return Number(value);
        },
        today() {
            // return this.$moment().format("YYYY-MM-DD");
            return moment().format("YYYY-MM-DD");
        },
        now() {
            return moment().format("YYYY-MM-DD HH:mm:ss");
        },
        ymd() {
            return moment().format("YYYYMMDD");
        },
        monthRange(date = this.today()) {
            date = moment(date);
            return { dateb: date.clone().startOf('month').format('YYYY-MM-DD'), datee: date.clone().endOf('month').format('YYYY-MM-DD') };
        },
        gReplace(value, find, replace) {
            // return value.replace(RegExp(find, "g"), replace);
            return value.replaceAll(find, replace);
        },
        gNl2br(text) {
            text = text.toString();
            return text.replaceAll("\n", "<br/>");
        },
        gGroupBy(data, key) {
            try {
                var output = [];
                var set = new Set();
                var res = data.filter(r => !set.has(r[key]) ? set.add(r[key]) : false);
                res.forEach(r => {
                    output.push(r[key])
                });
                return output;
            } catch (error) {
                console.log({ 檔案: __filename, 程序: "gGroupBy", 錯誤: error.toString() });
                return [];
            }
        },
        gGetItemcRst(obj) { //菜式物件 -> 陣列 (陣列[0]=主餐);
            var item = JSON.parse(JSON.stringify(obj)); // 轉字串再轉回來 避免影響到byval 傳入的物件

            var next = item.Next;
            if (next != undefined) { //處理woosa.下一步
                item.Groups.push(next);
            }
            // console.log("item", item.Groups);
            var data = this.gGetGroups(item);
            return data;
        },
        gGetGroups(obj, data = []) { //將itemc物件轉成陣列
            var groups = obj.Groups;
            if (groups == undefined) {
                return data;
            }
            // console.log("obj", obj);
            data.push(obj);

            for (let i = 0; i < groups.length; i++) {
                var options = groups[i].options;
                options.forEach(item => {
                    this.gGetGroups(item, data); //使用遞迴
                });
            }
            data.map((r) => { r.Groups = undefined });
            return data;
        },
    },
};